import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import {
  container,
  link,
  noResults,
  noResultsContainer,
  resultsContainer,
  showAll,
} from './styles.module.css';

import EventInfo from '../../../EventInfo';
import EventSearchRecommendRace from '../../../EventSearchRecommendRace';

export const EventSearchResults = (
  { countryCode, events, fetching, total, displayMax, query, onSelect },
) => (
  <div className={resultsContainer}>
    {events && !!total &&
    <div className={container}>
      {events.slice(0, displayMax).map(({
        id,
        location,
        races,
        permalink,
        startDate,
        startDateFormatted,
        images,
        title,
        reviews,
      }) => (
        <EventInfo
          id={id}
          key={id}
          location={location}
          races={races}
          logo={images.logo}
          permalink={permalink}
          startDate={startDate}
          startDateFormatted={startDateFormatted}
          title={title}
          reviews={reviews}
          onSelect={onSelect}
        />
      ))}
      {(events && (total > displayMax)) &&
      <div className={showAll}>
        Show all {total} results for ’{query}’
        <Link rel="nofollow" to={`/s?name=${query}${countryCode !== 'US' ? '&pastevents=true' : ''}`} className={link} onClick={onSelect} />
      </div>}
    </div>}
    {!total && !fetching &&
    <div className={noResultsContainer}>
      <div className={noResults}>
        <strong>No results</strong>
      </div>
      <EventSearchRecommendRace />
    </div>}
  </div>
);

EventSearchResults.propTypes = {
  /*
   * The code representing the country in which the session is taking place
   */
  countryCode: PropTypes.string,
  /*
   * Max number of results to display.
   */
  displayMax: PropTypes.number,
  /*
   * Array of events returned from API.
   */
  events: PropTypes.arrayOf(PropTypes.shape()),
  /**
   * Whether the searching query is currently fetching
   */
  fetching: PropTypes.bool,
  /*
   * Callback function when event is selected.
   */
  onSelect: PropTypes.func,
  /*
   * Search query (string).
   */
  query: PropTypes.string,
  /*
   * Total number of results returned from API.
   */
  total: PropTypes.number,
};

EventSearchResults.defaultProps = {
  countryCode: undefined,
  displayMax: 3,
  events: null,
  fetching: false,
  onSelect: () => {},
  query: undefined,
  total: 0,
};

const mapStateToProps = state => ({
  countryCode: state.countryCode,
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventSearchResultsWithRedux = connect(mapStateToProps)(EventSearchResults);  // eslint-disable-line no-class-assign, max-len

export default EventSearchResultsWithRedux;



// WEBPACK FOOTER //
// ./app/src/components/EventSearchName/components/EventSearchResults/index.jsx